/* DillySocks — Sticky-Kaufleiste (Mobile PDP): Zustand NACH dem
   In-den-Warenkorb-Legen (Sean 18.08.2026).

   Horizons <sticky-add-to-cart> bleibt unveraendert (Update-Sicherheit).
   Dieses Script lauscht auf das zentrale CartLinesUpdateEvent, das ALLE
   ATC-Wege feuern (Buybox-Button, Sticky-Button, Quick-Add-Slider,
   Bundle) — sobald die Cart-Anfrage erfolgreich war, schaltet die Leiste
   um: Produktinfo weg, stattdessen "Weiter einkaufen" (Pfeil zurueck)
   und "Zum Warenkorb" (Korb-Icon). "Weiter einkaufen" stellt den
   Normalzustand wieder her. Horizons eigene ATC-Animation auf dem runden
   Button laeuft vorher komplett durch — wir warten, bis Horizon sie
   selbst beendet (data-added wird entfernt). */
import { StandardEvents } from '@shopify/events';

(function () {
  'use strict';

  var ADDED_CLASS = 'ds-satc-added';

  /* Uebersetzte Button-Texte aus theme.liquid (Locale-Keys ds_satc.*,
     damit Translate & Adapt sie pflegen kann); deutsch nur als Fallback. */
  var T = Object.assign(
    { continueShopping: 'Weiter einkaufen', toCart: 'Zum Warenkorb' },
    window.DS_SATC_I18N || {}
  );

  /* Horizons <sticky-add-to-cart> UND unsere eigenen Leisten (Abo,
     Adventskalender: snippets/ds-sticky-bar) — gleiche Klassen. */
  function bar() {
    return document.querySelector('.sticky-add-to-cart .sticky-add-to-cart__bar');
  }

  /* Eigene Leisten (.ds-sticky-bar): Horizons Custom Element fehlt, also
     Sichtbarkeit und Klick selbst regeln.
     - sichtbar, sobald der Haupt-Kaufbutton (data-ds-sticky-watch) oben aus
       dem Bild gescrollt ist
     - Klick auf den runden Button = Klick auf den Haupt-Kaufbutton; die
       Haekchen-Animation (data-added) laeuft auf dem runden Button, das
       Cart-Event kommt aus dem Sektions-JS. Kommt binnen 3s kein Event
       (z.B. Abo ohne gewaehlte Groesse), Animation zuruecknehmen. */
  var pendingSelfClick = null;
  function initCustomBars() {
    document.querySelectorAll('.ds-sticky-bar[data-ds-sticky-watch]').forEach(function (wrap) {
      if (wrap.dataset.dsReady) return;
      var target = document.querySelector(wrap.dataset.dsStickyWatch);
      var b = wrap.querySelector('.sticky-add-to-cart__bar');
      var btn = wrap.querySelector('[data-ds-sticky-add]');
      if (!target || !b || !btn) return;
      wrap.dataset.dsReady = '1';
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var en = entries[0];
          if (!en) return;
          var above = !en.isIntersecting && en.boundingClientRect.bottom < 0;
          b.dataset.stuck = above ? 'true' : 'false';
        }).observe(target);
      }
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        btn.dataset.added = 'true';
        if (pendingSelfClick) clearTimeout(pendingSelfClick);
        pendingSelfClick = setTimeout(function () {
          if (!b.classList.contains(ADDED_CLASS)) btn.removeAttribute('data-added');
        }, 3000);
        target.click();
      });
    });
  }

  function ensureActions(b) {
    if (b.querySelector('.ds-satc__actions')) return;
    var wrap = document.createElement('div');
    wrap.className = 'ds-satc__actions';
    wrap.innerHTML =
      '<button type="button" class="ds-satc__btn ds-satc__btn--back" data-ds-satc-back>' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>' +
        '<span>' + T.continueShopping + '</span>' +
      '</button>' +
      '<a class="ds-satc__btn ds-satc__btn--cart" href="/cart" data-ds-satc-cart>' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>' +
        '<span>' + T.toCart + '</span>' +
      '</a>';
    b.appendChild(wrap);
    /* "Weiter einkaufen": zurueck zur Collection, von der man kam
       (Referrer im eigenen Shop mit /collections/). Ohne solchen Referrer
       (Direkteinstieg) auf die Fallback-Collection aus data-ds-back-url am
       <body> (Kids -> Familiensocken, sonst Bunte Socken). */
    wrap.querySelector('[data-ds-satc-back]').addEventListener('click', function () {
      b.classList.remove(ADDED_CLASS);
      /* Button zuruecksetzen (Horizon tut das ohne sein Header-Cart-Icon
         nicht), sonst bliebe das Haekchen stehen. */
      var btn = b.querySelector('.sticky-add-to-cart__button');
      if (btn) btn.removeAttribute('data-added');
      var ref = document.referrer || '';
      var fromCollection = false;
      try {
        var u = new URL(ref);
        fromCollection = u.origin === location.origin && u.pathname.indexOf('/collections/') !== -1;
      } catch (err) { /* kein/ungueltiger Referrer */ }
      if (fromCollection && history.length > 1) { history.back(); return; }
      var fallback = document.body.getAttribute('data-ds-back-url') || '/collections/bunte-socken';
      location.href = fallback;
    });
    /* Warenkorb-Link: Horizons Drawer oeffnen statt Seitenwechsel, wenn
       vorhanden — sonst normale Navigation auf /cart */
    wrap.querySelector('[data-ds-satc-cart]').addEventListener('click', function (e) {
      var drawer = document.querySelector('cart-drawer-component, #cart-drawer');
      if (drawer && typeof drawer.open === 'function') { e.preventDefault(); drawer.open(); }
      else if (drawer && drawer.querySelector('dialog') && !drawer.querySelector('dialog').open) {
        var trg = document.querySelector('[on\\:click="#cart-drawer/toggle"], .ds-hd__cart');
        if (trg) { e.preventDefault(); trg.click(); }
      }
    });
  }

  /* Umschalten erst, wenn Horizons Haekchen-Animation auf dem runden
     Sticky-Button komplett durch ist: Horizon setzt data-added="true" beim
     Klick und entfernt es nach Animationsende + 800ms. Darauf warten wir
     (MutationObserver, Sicherheitsnetz 4s). Kam der ATC von einem anderen
     Button (Buybox, Quick-Add), traegt der Sticky-Button kein data-added —
     dann reicht ein kurzer Moment nach der erfolgreichen Cart-Antwort. */
  function switchWhenAnimationDone(b) {
    var btn = b.querySelector('.sticky-add-to-cart__button');
    var show = function () { b.classList.add(ADDED_CLASS); };
    if (!btn || btn.dataset.added !== 'true') {
      setTimeout(show, 300);
      return;
    }
    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      mo.disconnect();
      btn.removeEventListener('transitionend', onEnd);
      show();
    };
    var mo = new MutationObserver(function () {
      if (btn.dataset.added !== 'true') finish();
    });
    mo.observe(btn, { attributes: true, attributeFilter: ['data-added'] });
    /* Horizon setzt data-added nur zurueck, wenn es sein Header-Cart-Icon
       findet (bei unserem eigenen Header nicht) — deshalb zusaetzlich das
       Ende der letzten Teil-Animation (Strahlen, stroke-dashoffset)
       abwarten und dann noch 600ms Haekchen zeigen. */
    var onEnd = function (ev) {
      if (ev.propertyName === 'stroke-dashoffset') setTimeout(finish, 600);
    };
    btn.addEventListener('transitionend', onEnd);
    setTimeout(finish, 3000);
  }

  function onCartUpdate(e) {
    var b = bar();
    if (!b) return;
    /* Horizon rendert die Leiste beim Variantenwechsel neu (Section-Morph)
       und verwirft dabei unsere eingehaengten Buttons — ohne dieses erneute
       ensureActions erschien nach ATC nur ein LEERER Balken (Sean 27.08.).
       Der Guard in ensureActions macht den Aufruf idempotent. */
    ensureActions(b);
    if (pendingSelfClick) { clearTimeout(pendingSelfClick); pendingSelfClick = null; }
    var go = function () { switchWhenAnimationDone(b); };
    if (e && e.promise instanceof Promise) {
      /* nur bei Erfolg umschalten */
      e.promise.then(go).catch(function () { /* Fehler: Leiste bleibt normal */ });
    } else {
      go();
    }
  }

  function init() {
    initCustomBars();
    var b = bar();
    if (!b) return;
    ensureActions(b);
    /* Denselben Event-Namen verwenden wie Horizons eigene Komponenten
       (cart-drawer, cart-icon, sticky-add-to-cart) — kein Raten. */
    document.addEventListener(StandardEvents.cartLinesUpdate, onCartUpdate);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
